<template>
    <div>
        <form @submit.prevent="on_submit" id="excel_form">
            <div v-if="errors" class="mx-4 kt-alert kt-alert--outline alert alert-danger alert-dismissible">
                <ul>
                    <li class="text-white" :key="error" v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
            <div class="d-flex justify-content-between my-4">
                <div class="h5" v-text="$t('wallets.label.settlement_request_with_excel')"></div>
                <div>
                    <router-link class="btn btn-success my-2 btn-width-100" to="/wallets">
                        {{ $t('label.back') }}
                    </router-link>
                </div>
            </div>
            <div class="row justify-content-center my-4">
                <div class="col-12 col-md-6 my-2">
                    <label for="password" v-text="$t('label.wallet_password')"></label>
                    <input class="form-control" id="password" name="password" type="password"
                        v-model="form_data.password">
                </div>
            </div>
            <div class="rounded-circle border border-success p-2 mx-auto"
                style="width: fit-content; border-width: 3px !important">
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="48px"
                    viewBox="0 0 24 24" width="48px" fill="#00bea5">
                    <rect fill="none" height="24" width="24" />
                    <g>
                        <path
                            d="M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1C4.76,14.04,4.39,14,4,14 c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2 c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85C21.93,14.21,20.99,14,20,14 c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M16.24,13.65c-1.17-0.52-2.61-0.9-4.24-0.9 c-1.63,0-3.07,0.39-4.24,0.9C6.68,14.13,6,15.21,6,16.39V18h12v-1.61C18,15.21,17.32,14.13,16.24,13.65z M8.07,16 c0.09-0.23,0.13-0.39,0.91-0.69c0.97-0.38,1.99-0.56,3.02-0.56s2.05,0.18,3.02,0.56c0.77,0.3,0.81,0.46,0.91,0.69H8.07z M12,8 c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,8,12,8 M12,6c-1.66,0-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3 C15,7.34,13.66,6,12,6L12,6z" />
                    </g>
                </svg>
            </div>

            <div class="my-3 d-flex justify-content-center">
                <ul class="text-right list-unstyled">
                    <li class="bg-white mb-3">
                        لطفا به نکات زیر در تکمیل فایل اکسل توجه نمایید:
                    </li>
                    <li class="mb-2">
                        <img src="@/pages/dashboard/userwizard/assets/check.svg" width="16" height="16"
                            class="filter_green" /><span class="mx-3">قالب اکسل باید مشابه
                            <a :href="excelTemplateLink()">
                                <strong style="color: red">
                                    {{ $t("money_request.file_hint_second") }}
                                </strong>
                            </a>
                            باشد</span>
                    </li>
                    <li class="mb-2">
                        <img src="@/pages/dashboard/userwizard/assets/check.svg" width="16" height="16"
                            class="filter_green" /><span class="mx-3">نام و نام خانوادگی گیرنده تنها با حروف فارسی
                            باید
                            باشد</span>
                    </li>
                    <li class="mb-2">
                        <img src="@/pages/dashboard/userwizard/assets/check.svg" width="16" height="16"
                            class="filter_green" /><span class="mx-3">شماره شبا باید با "IR" شروع شود، شامل ۲۶ کاراکتر
                            باشد و فقط اعداد (بدون فاصله یا کاراکترهای اضافی) را در بر گیرد.</span>
                    </li>
                    <li class="mb-2">
                        <img src="@/pages/dashboard/userwizard/assets/check.svg" width="16" height="16"
                            class="filter_green" /><span class="mx-3">مجموع درخواست ها نباید بیشتر از ۱۰۰ باشد.</span>
                    </li>
                    <li class="mb-2">
                        <img src="@/pages/dashboard/userwizard/assets/check.svg" width="16" height="16"
                            class="filter_green" /><span class="mx-3">تکمیل فیلد شناسه واریز اختیاری است</span>
                    </li>
                    <li class="mb-2">
                        <img src="@/pages/dashboard/userwizard/assets/check.svg" width="16" height="16"
                            class="filter_green" /><span class="mx-3">تکمیل فیلد شناسه شرکت اختیاری است</span>
                    </li>
                    <li class="mb-2">
                        <img src="@/pages/dashboard/userwizard/assets/check.svg" width="16" height="16"
                            class="filter_green" /><span class="mx-3">تکمیل فیلد توضیحات اختیاری است</span>
                    </li>
                </ul>
            </div>

            <div>
                <label for="file" class="d-block  btn btn-outline-success btn-pill label-file  mx-auto">
                    <kt-icon type="fa" name="paperclip"></kt-icon>
                    {{ $t("money_request.select_file") }}
                </label>
                <input @change="processExcelFile" type="file" class="custom-file-upload d-none" name="file" id="file"
                    accept=".xlsx" />
            </div>
            <hr class="my-4" />
            <div v-if="should_two_factor_settlement">
                <button :disabled="form_meta_data.submit_btn_progress" class="btn btn-success mr-auto"
                    id="submit_button" type="submit">
                    <div class="d-flex align-items-center">
                        <div v-text="$t('btn.send_code')"></div>
                        <div class="ml-2 spinner-border spinner-border-sm" role="status"
                            v-if="form_meta_data.submit_btn_progress"></div>
                    </div>
                </button>
            </div>
            <div v-else>
                <button :disabled="form_meta_data.submit_btn_progress" class="btn btn-success mr-auto"
                    id="submit_button" type="submit">
                    <div class="d-flex align-items-center">
                        <div v-text="$t('wallets.btn.create_settlement_request')"></div>
                        <div class="ml-2 spinner-border spinner-border-sm" role="status"
                            v-if="form_meta_data.submit_btn_progress"></div>
                    </div>
                </button>
            </div>
        </form>
        <otp-modal :loading="form_meta_data.submit_btn_progress" :message="$t('label.input_verification_code')"
            :two_factor_type="form_data.two_factor_type" @emitAction="setOtp" @sendRequest="sendRequest" />
    </div>
</template>

<script>

import $ from 'jquery';
import Axios from 'axios';
import { i18n } from "@/plugins/i18n";
import Inputmask from 'inputmask';
import otpModal from "@/components/elements/modal/otp-modal.vue";
import { walletService } from "@/common/api.service";
import {TwoFactorType} from "@/constants/TwoFactorType";
import {BASE_PATH} from "@/common/config";

export default {
    components: {otpModal},
    data() {
        return {
            wallet_amount: null,
            last_iban_check: '',
            should_two_factor_settlement: false,
            errors: null,
            form_data: {
                file: '',
                password: '',
                should_two_factor_settlement: false,
                two_factor_type: ''
            },
        };
    },

    mounted() {
        Axios.get('wallet/common?wallet_prefix=A').then(response => {
            response.data.data.forEach(wallet => {
                if (wallet.id === this.$route.params.hashid) {
                    this.wallet_amount = wallet.available_amount;
                    this.should_two_factor_settlement = wallet.should_two_factor_settlement;
                    this.form_data.should_two_factor_settlement = wallet.should_two_factor_settlement;
                }
            })
        });
    },

    props: {
        form_meta_data: {
            type: Object,
            default: () => {
                return {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('btn.submit'),
                };
            },
        },
        password: Object,
    },

    methods: {
        on_submit() {

            if (!this.form_data.should_two_factor_settlement) {
                this.settlement()
                return;
            }

            let form = $('#excel_form');

            form.validate({
                rules: {
                    password: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                window.scrollTo({ top: 1, behavior: 'smooth' });
                return;
            }

            this.form_meta_data.submit_btn_progress = true;
            this.form_data.otp = '';

            let params = {
                wallet_id: this.$route.params.hashid,
                password: this.form_data.password,
                two_factor_type: this.form_data.two_factor_type,
            };

            walletService.sendVerificationCode(params).then(response => {

                this.form_data.two_factor_type = response.data.data.two_factor_type;

                this.masked();

                $('#approve_modal').modal('show');
                this.$forceUpdate();

                this.toastr.success(response.data.message);

            }).catch(({ response }) => {

                this.showMsg(form, 'danger', response.data.message);
                if (response.data && response.data.data) {
                    form.validate().showErrors(response.data.data);
                }

                window.scrollTo({ top: 1, behavior: 'smooth' });
            }).finally(() => {
                this.form_meta_data.submit_btn_progress = false;
            });
        },
        formatErrors(responseData) {
            const formattedErrors = [];

            const errors = responseData.data;

            if (Object.keys(errors).length > 0) {

                Object.keys(errors).forEach((key) => {
                    if (key.startsWith("transfers.")) {
                        const row = key.split(".")[1];
                        formattedErrors.push(...errors[key].map((message) => `ردیف ${row}: ${message}`));
                    } else {
                        formattedErrors.push(...errors[key].map(message => message));
                    }
                });
            } else {
                formattedErrors.push(responseData.message);
            }

            return formattedErrors;
        },
        processExcelFile(e) {
            this.form_data.file = event.target.files[0];
            this.validateSize(event.target);
            this.validateFormat(event.target);
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t("money_request.file_size_hint"));
                $(file).val("");
            } else {
            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, "");
            if (extension === file_name) {
                extension = "";
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case "xlsx":
                    break;
                default:
                    alert(i18n.t("authenticate.input_format_err"));
                    $(file).val("");
            }
        },
        settlement() {
            let form = $('#excel_form');

            form.validate({
                rules: {
                    password: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                window.scrollTo({ top: 1, behavior: 'smooth' });
                return;
            }

            let params = {
                wallet_hashid: this.$route.params.hashid,
                otp: !this.form_data.otp ? '' : this.toEng(this.form_data.otp),
                two_factor_type: !this.form_data.two_factor_type ? '' : this.form_data.two_factor_type,
                file: this.form_data.file,
                should_two_factor_settlement: this.should_two_factor_settlement ? 1 : 0,
                password: this.form_data.password,
            };

            this.form_meta_data.submit_btn_progress = true;

            walletService.settlementAyandeWithExcelRequest(params, this.$route.params.hashid).then(response => {
                $('#approve_modal').modal('hide');
                this.$router.push('/wallets');
            }).catch(({ response }) => {

                window.scrollTo({ top: 1, behavior: 'smooth' });

                if (response.data) {
                    this.errors = this.formatErrors(response.data);
                }

            }).finally(() => {
                this.form_meta_data.submit_btn_progress = false;
            });
        },
        sendRequest(type) {
            this.form_data.two_factor_type = type;
            if (type === TwoFactorType.SMS) this.on_submit()
        },
        setOtp(data) {
            this.form_data.otp = data;            
            this.$emit('settlement_excel')
        },
        masked() {
            setTimeout(() => {
                document.getElementById("google_authenticator_code") &&
                    Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
            }, 100);
        },
        excelTemplateLink() {
            return BASE_PATH + "/wallet/settlement/download-template";
        },
    }
}
</script>

<style scoped>
.filter_green {
    filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.back-flex {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
}

a:hover.wage_wallet {
    color: gray;
}

ul {
    margin: 0;
    padding: 0;
}

ul>li {
    list-style-type: none;
}
</style>
